import { useForm } from 'react-hook-form';
import { formResolver } from 'src/utils/formResolver';
import { object } from 'yup';
import { stringScheme } from 'src/utils/validation-schemes';
import { useGetProjectByIdQuery } from 'src/services';
import { useParams } from 'react-router-dom';
import * as yup from 'yup';
import type { SelectedIntegration } from 'src/store/slices/integrationSlice';
import type { IntegrationSubmitHandler } from 'src/components/Integrations/integrationFormTypes';
import { ZohoEmailApiFields } from 'src/components/Integrations/IntegrationForms/IntegrationFormFields/ZohoEmailApiFields/ZohoEmailApiFields';

export const IntegrationFormZohoEmail = ({
  integration,
  onSubmit,
}: {
  integration?: SelectedIntegration;
  onSubmit?: IntegrationSubmitHandler;
}) => {
  const { id } = useParams();
  const { data: currentProject } = useGetProjectByIdQuery({ id: id });
  const { handleSubmit, control } = useForm({
    defaultValues: {
      name: integration?.integration_data?.name || '',
      client_id: integration?.integration_data?.client_id || '',
      client_secret: integration?.integration_data?.client_secret || '',
      scope: integration?.integration_data?.scope || 'Desk.tickets.ALL,Desk.basic.READ',
      server_locale: integration?.integration_data?.server_locale || '',
      integration_method: integration?.integration_data?.token ? 'token' : 'code',
      code: integration?.integration_data?.code || '',
      refresh_token: integration?.integration_data?.refresh_token || '',
    },
    resolver: formResolver(
      yup.lazy((values) => {
        return object({
          name: stringScheme({ required: false }).label('Integration Name'),
          client_id: stringScheme({ required: true }).label('Client ID'),
          client_secret: stringScheme({ required: true }).label('Client secret'),
          scope: stringScheme({ required: true }).label('Scope'),
          server_locale: stringScheme({ required: true }).label('Server locale'),
          code: stringScheme({ required: values.integration_method === 'code' }).label('Code'),
          refresh_token: stringScheme({ required: values.integration_method !== 'code' }).label(
            'Refresh Token',
          ),
        });
      }),
    ),
  });

  const submit = (data: {
    name: string;
    client_id: string;
    client_secret: string;
    scope: string;
    server_locale: string;
    integration_method: string;
    code: string;
    refresh_token: string;
  }) => {
    const result = {
      ...integration,
      integration_data: {
        ...integration.integration_data,
        name: currentProject.name,
        client_id: data.client_id,
        client_secret: data.client_secret,
        scope: data.scope,
        server_locale: data.server_locale,
        code: data.code,
        refresh_token: data.refresh_token,
      },
    };

    if (data.integration_method === 'code') {
      delete result.integration_data.refresh_token;
    } else {
      delete result.integration_data.code;
    }

    onSubmit(result);
  };

  return (
    <form id="integration-form" onSubmit={handleSubmit(submit)}>
      <ZohoEmailApiFields control={control} fieldClassName="content" />
    </form>
  );
};
